import { render, staticRenderFns } from "./check_bom.vue?vue&type=template&id=6aa35884&scoped=true&"
import script from "./check_bom.vue?vue&type=script&lang=js&"
export * from "./check_bom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa35884",
  null
  
)

export default component.exports